import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
import { resolveLibraryFolder } from "../../services/libraryService";
import LibraryCatalogPage from "./LibraryCatalogPage";
import Loader from "../utilPages/Loader";

const LibraryFolderPage = () => {
  const { slug } = useParams();
  const { language, token } = useAppContext();
  const [folder, setFolder] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setFolder(null);
    setNotFound(false);
    resolveLibraryFolder(`/library/${slug}`, token)
      .then((data) => {
        if (!cancelled) setFolder(data);
      })
      .catch(() => {
        if (!cancelled) setNotFound(true);
      });
    return () => {
      cancelled = true;
    };
  }, [slug, token]);

  if (notFound) return <Navigate to="/library" replace />;
  if (!folder) return <Loader load />;

  return (
    <LibraryCatalogPage
      pageTitle={language === "russian" ? folder.name.ru : folder.name.en}
      folderId={folder._id}
      hideFilters={folder.hideFilters}
    />
  );
};

export default LibraryFolderPage;
